import { Box, Col, Image, Text } from '@opendoor/bricks-next';
import type { EntryComponent } from 'cms/entries/entries';
import type { IComparePhotoTestimonials } from 'declarations/contentful';

import { resizeTestimonialCardImageUrl } from './shared/utils';

const RenderComparePhotoTestimonials = (entry: IComparePhotoTestimonials) => {
  const { fields } = entry;

  return (
    <Box backgroundColor="$backgroundPrimary" py="$40x" $smallerThanMD={{ py: '$24x' }}>
      <Box display="block" maxWidth={1120} px="$12x" width="100%" mx="auto">
        <Col gap="$12x">
          <Col gap="$6x">
            <Text tag="p" typography="$labelSmall" fontWeight="$medium" color="$contentAccentBrand">
              {fields.eyebrow}
            </Text>
            <Text
              tag="h2"
              typography="$subheaderLarge"
              color="$contentPrimary"
              $smallerThanMD={{ typography: '$subheaderMedium' }}
            >
              {fields.title}
            </Text>
            <Text
              tag="p"
              typography="$bodyLarge"
              color="$contentSecondary"
              maxWidth={580}
              $platform-web={{ lineHeight: '1.6' }}
            >
              {fields.description}
            </Text>
          </Col>

          <Box flexDirection="column" gap="$12x" $largerThanSM={{ flexDirection: 'row' }}>
            {fields.cards.map((card) => (
              <Col
                key={card.sys.id}
                flex={1}
                borderRadius="$8x"
                backgroundColor="$backgroundSecondary"
                $platform-web={{ overflow: 'hidden' }}
              >
                <Image
                  source={{ uri: resizeTestimonialCardImageUrl(card.fields.imageUrl) }}
                  alt={card.fields.imageAlt || card.fields.name}
                  width="100%"
                  height={220}
                  $platform-web={{ objectFit: 'cover', loading: 'lazy' }}
                />
                <Col p="$12x" gap="$10x">
                  <Text
                    tag="p"
                    typography="$bodySmall"
                    color="$contentPrimary"
                    $platform-web={{ lineHeight: '1.7' }}
                  >
                    &ldquo;{card.fields.quote}&rdquo;
                  </Text>
                  <Col gap="$1x">
                    <Text tag="span" typography="$labelSmall" color="$contentPrimary">
                      {card.fields.name}
                    </Text>
                    <Text tag="span" typography="$bodyXsmall" color="$contentTertiary">
                      {card.fields.location}
                    </Text>
                  </Col>
                </Col>
              </Col>
            ))}
          </Box>
        </Col>
      </Box>
    </Box>
  );
};

const ComparePhotoTestimonials: EntryComponent<IComparePhotoTestimonials> = {
  render: RenderComparePhotoTestimonials,
};

export default ComparePhotoTestimonials;
